import {Visibilite} from "@domain/geolocalisation/localisation";
import {LieuParam} from "@domain/common/lieu/lieu-param";

/**
 * Paramétrage pour la partie profil du lieu
 */
export class LieuParamProfil extends LieuParam {
    /** {@inheritDoc} */
    urlAdresse = `/controller/ProfilUser/getAdresse`;

    /** {@inheritDoc} */
    titleAdresseTab = "lieu.tabs.mesAdresses";

    /** {@inheritDoc} */
    listeVisibiliteLocalisation = [Visibilite.FILTRE_V_PROFIL]

    /** {@inheritDoc} */
    isSaisieAutorisee = () => true;

    /** {@inheritDoc} */
    placeHolder = (libelleAdresse: String,isDisabled: boolean) => {
        return libelleAdresse
            ? ''
            : isDisabled
                ? 'lieu.aucuneSelection'
                : 'profilUser.adresses.add.selection';
    };

    /** {@inheritDoc} */
    isOngletSaisieWithAdresseIncomplete = true;

    /** {@inheritDoc} */
    isShowAdresseFiltre = true;

    /** {@inheritDoc} */
    isShowProPersoAdresseFiltre = false;

    /** {@inheritDoc} */
    isFormatRueFromString = true;

    /** {@inheritDoc} */
    isRueRequired = true;

    /** {@inheritDoc} */
    isShowAdminAndUserAdresse = true;

    /**
     * Constructeur
     */
    constructor(idUser: number) {
        super();

        this.idUser = idUser;
    }
}